import { Container, Typography, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CircularProggressIndicator } from "../components-atoms/CircularProggressIndicator";
import { InfoCard } from "../components-molecules/InfoCard";
import { ShopRegionHeadline } from "../components-atoms";
import { IFilter, clearGetShops, getShops } from "../redux/actions/getShops";
import { useHistory } from "react-router";
import InfiniteScroll from "react-infinite-scroll-component";
import { LoadMoreIndicator } from "../components-atoms/LoadMoreIndicator";

type SortType = "asc" | "desc";
interface IProps {
  sortType: SortType;
  filters: IFilter;
  query: string;
  refresh: boolean;
  resetRefresh: () => void;
}
export const ShopInfoCardList = (props: IProps) => {
  const { query, sortType, refresh, resetRefresh } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const shopsLoading = useSelector((state: any) => state.shopList.loading);
  const [shopsData, dataTotalCount] = useSelector((state: any) => [
    state.shopList.data,
    state.shopList.totalCount,
  ]);

  useEffect(() => {
    dispatch(clearGetShops());
    return () => {
      dispatch(clearGetShops());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!refresh) {
      fetchData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortType, query, page, props.filters]);

  useEffect(() => {
    if (refresh) {
      setPage(1);
      resetRefresh();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  const fetchData = () => {
    let filters = {};
    Object.entries(props.filters).forEach(([key, value]: any) => {
      if (value && value?.length > 0) {
        filters[key] = value;
      } else {
        filters[key] = null;
      }
    });

    dispatch(
      getShops({
        Order: props.sortType,
        Page: page,
        Size: pageSize,
        Query: query,
        Filter: filters,
      })
    );
  };

  const getDataLength = () => {
    let count = 0;
    if (shopsData?.length > 0) {
      shopsData.forEach((item) => {
        count += item.Shops.length;
      });
    }
    return count;
  };

  const loadMoreData = () => {
    setPage(page + 1);
  };

  return (
    <InfiniteScroll
      style={{ overflow: "hidden" }}
      dataLength={getDataLength()}
      next={loadMoreData}
      hasMore={getDataLength() < dataTotalCount}
      scrollThreshold={0.99}
      loader={<LoadMoreIndicator />}
    >
      <Container className={classes.component}>
        {shopsLoading && getDataLength() === 0 ? (
          <CircularProggressIndicator />
        ) : getDataLength() === 0 ? (
          <Container className={classes.noRecordsFound}>
            <Typography variant="body1" component="span">
              No records found
            </Typography>
          </Container>
        ) : (
          <>
            {shopsData &&
              shopsData.map((item: any, index: any) => (
                <div key={index}>
                  {item?.Shops?.length > 0 && (
                    <ShopRegionHeadline
                      data={{ header: item.Region, count: item.Shops.length }}
                    />
                  )}
                  {item?.Shops &&
                    item?.Shops.map((item: any) => (
                      <InfoCard
                        type="shop"
                        key={item.Id}
                        data={{
                          ...item,
                          bottomText: `${item?.City} · ${item?.County} · ${item?.PostalCode}`,
                          topText: `${item.Name}`,
                          IsShopInactive: item.Archived,
                        }}
                        onClick={() => {
                          history.push("/merchant/shops/" + item.Id);
                        }}
                      />
                    ))}
                </div>
              ))}
          </>
        )}
      </Container>
    </InfiniteScroll>
  );
};
const useStyles = makeStyles({
  component: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 0,
    paddingRight: 0,
  },
  noRecordsFound: {
    display: "flex",
    paddingLeft: "24px",
  },
});
